<app-auth-layout
  variant="split"
  [headline]="'user.authAside.forgotPassword.' + view + '.headline' | transloco"
  [tagline]="'user.authAside.forgotPassword.' + view + '.tagline' | transloco"
  [step]="step"
  [stepCount]="3"
  [languages]="languageOptions" [currentLanguage]="language" (languageChange)="selectLanguage($event)">
  <div [style.display]="isNotDivPass">
    <div [style.display]="isDivEmail">
      <h2 class="auth-title">{{ 'user.forgotPassword.title' | transloco }}</h2>
      <p class="auth-subtitle">{{ 'user.forgotPassword.emailHint' | transloco }}</p>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="field-group">
          <label class="field-label" for="email">{{ 'user.login.email' | transloco }}</label>
          <input
            class="text-input"
            id="email"
            type="email"
            autocomplete="email"
            formControlName="email"
            [placeholder]="'user.forgotPassword.enterEmail' | transloco"
          />
        </div>
        <div class="auth-actions">
          <button class="chamfer" type="submit" [disabled]="submitBtnLoading">
            <i *ngIf="submitBtnLoading" class="pi pi-spin pi-spinner"></i>
            {{ 'user.forgotPassword.btnSend' | transloco }}
          </button>
          <button class="chamfer outline" type="button" (click)="backLogin()">{{ 'common.buttons.back' | transloco }}</button>
        </div>
      </form>
    </div>

    <div [style.display]="isDivCode">
      <div class="auth-status-tile" aria-hidden="true">
        <svg viewBox="0 0 24 24"><rect x="3" y="5" width="18" height="14" rx="2"/><polyline points="3,7 12,13 21,7"/></svg>
      </div>
      <h2 class="auth-title">{{ 'user.forgotPassword.title2' | transloco }}</h2>
      <p class="auth-subtitle">{{ 'user.forgotPassword.sentTo' | transloco }} <strong>{{ email }}</strong>.</p>
      <p class="help-text">{{ 'user.forgotPassword.linkMsg' | transloco }}</p>
      <div class="auth-actions">
        <button class="chamfer outline" type="button" (click)="backLogin()">{{ 'common.buttons.back' | transloco }}</button>
      </div>
      <p class="resend-row">
        {{ 'user.forgotPassword.resend' | transloco }}
        <button class="text-link" type="button" (click)="sendEmailAgain()" [disabled]="isButtonDisabled">
          {{ 'user.forgotPassword.resend2' | transloco }}
        </button>
        <span *ngIf="isButtonDisabled">{{ countdownLabel }}</span>
      </p>
    </div>
  </div>

  <div [style.display]="isDivPass">
    <h2 class="auth-title">{{ 'user.forgotPassword.header2' | transloco }}</h2>
    <p class="auth-subtitle new-password-subtitle">{{ 'user.forgotPassword.title3' | transloco }} <strong>{{ email }}</strong></p>
    <form [formGroup]="formPass" (ngSubmit)="onSubmitPass()">
      <div class="field-group">
        <label class="field-label" for="password">{{ 'user.forgotPassword.newPass' | transloco }}</label>
        <div class="input-wrap">
          <input
            class="text-input"
            id="password"
            formControlName="password"
            autocomplete="new-password"
            [type]="showPassword ? 'text' : 'password'"
            [placeholder]="'user.forgotPassword.newPass' | transloco"
          />
          <button
            class="eye"
            type="button"
            (click)="showPassword = !showPassword"
            [attr.aria-pressed]="showPassword"
            [attr.aria-label]="(showPassword ? 'user.login.hidePassword' : 'user.login.showPassword') | transloco"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"/><circle cx="12" cy="12" r="2.5"/></svg>
          </button>
        </div>
      </div>
      <app-password-strength-checklist [password]="formPass.get('password')?.value"></app-password-strength-checklist>

      <div class="field-group confirm-group">
        <label class="field-label" for="passwordConfirm">{{ 'user.forgotPassword.confirmPass' | transloco }}</label>
        <div class="input-wrap">
          <input
            class="text-input"
            id="passwordConfirm"
            formControlName="passwordConfirm"
            autocomplete="new-password"
            [type]="showPasswordConfirm ? 'text' : 'password'"
            [placeholder]="'user.forgotPassword.confirmPass' | transloco"
          />
          <button
            class="eye"
            type="button"
            (click)="showPasswordConfirm = !showPasswordConfirm"
            [attr.aria-pressed]="showPasswordConfirm"
            [attr.aria-label]="(showPasswordConfirm ? 'user.login.hidePassword' : 'user.login.showPassword') | transloco"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z"/><circle cx="12" cy="12" r="2.5"/></svg>
          </button>
        </div>
      </div>

      <div class="auth-actions">
        <button class="chamfer" type="submit" [disabled]="submitBtnLoading">
          <i *ngIf="submitBtnLoading" class="pi pi-spin pi-spinner"></i>
          {{ 'user.forgotPassword.btnConfirmPass' | transloco }}
        </button>
        <button class="chamfer outline" type="button" (click)="backLogin()">{{ 'common.buttons.back' | transloco }}</button>
      </div>
    </form>
  </div>
</app-auth-layout>

<p-toast key="toastMessages" />
